import { Modal } from '@mui/material';
import { Button } from '@src/components/ui/button/button';
import { Form } from '@src/components/ui/react-hook-form/form/form';
import { SubmitButton } from '@src/components/ui/react-hook-form/submit-button/submit-button';
import { TextInput } from '@src/components/ui/react-hook-form/text-Input/text-input';
import React from 'react';
import PropTypes from 'prop-types';
import { ADDRESS_VALIDATOR } from './validator';
import { queryClient } from '@src/lib/query-client';
import { axios } from '@src/lib/axios';
import { cn } from '@src/utils/ui';

export const CreateBillingAddress = ({ open, onClose, user, validatePermissionToPerformAction }) => {
    const defaultValues = {
        Country: { alpha2code: 'CA', name: 'Canada' },
        State: 'BC'
    };

    const handleSubmit = async values => {
        await new Promise(resolve => {
            validatePermissionToPerformAction('add-consumer-checkout-api', async () => {
                await axios.post('/users/address/create', {
                    Name: [values.FirstName, values.LastName].filter(Boolean).join(' '),
                    Line1: values.Line1,
                    PostCode: values.PostalCode.toUpperCase(),
                    City: values.City,
                    CountryCode: values.Country.alpha2code,
                    State: values.State,
                    Email: user.Email,
                    Delivery: true,
                    Pickup: false,
                    guestUserID: user.ID
                });

                resolve();
            });
        });

        queryClient.refetchQueries({ queryKey: 'billingAddress', exact: true });
        onClose();
        return true;
    };

    return (
        <Modal open={open} onClose={onClose}>
            <div
                className={cn([
                    'tw-absolute tw-top-1/2 tw-left-1/2 tw-transform tw--translate-x-1/2 tw--translate-y-1/2',
                    'tw-w-[400px] tw-max-w-[90vw] tw-bg-white tw-border-2 tw-shadow-2xl tw-py-[16px]'
                ])}
            >
                <Form
                    className='tw-flex tw-flex-col tw-gap-[16px] tw-h-[550px] tw-max-h-[90vh]'
                    onSubmit={handleSubmit}
                    validator={{ schema: ADDRESS_VALIDATOR }}
                    defaultValues={defaultValues}
                >
                    <div className='tw-font-medium tw-text-[20px] tw-px-[24px]'>Add new billing address</div>
                    <div className='tw-space-y-[16px] tw-overflow-auto tw-grow tw-px-[24px]'>
                        <TextInput
                            name='FirstName'
                            label='First Name'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-white'
                            }}
                        />
                        <TextInput
                            name='LastName'
                            label='Last Name'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-white'
                            }}
                        />
                        <TextInput
                            name='Line1'
                            label='Address'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-white'
                            }}
                        />
                        {/* <CountrySelectInput name='Country' label='country' disabled /> */}
                        <TextInput
                            name='State'
                            label='Province'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-[rgba(0,80,196,0.04)]'
                            }}
                            disabled
                        />
                        <TextInput
                            name='City'
                            label='City'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-white'
                            }}
                        />
                        <TextInput
                            name='PostalCode'
                            label='Postal Code'
                            variant='outlined'
                            className='tw-w-full'
                            InputProps={{
                                className: 'tw-text-[16px] tw-bg-white'
                            }}
                            inputProps={{
                                className: 'tw-uppercase'
                            }}
                        />
                    </div>
                    <div className='tw-flex tw-justify-end tw-gap-[8px] tw-px-[24px]'>
                        <Button className='tw-text-[16px] tw-text-primary-500' onClick={onClose}>
                            CANCEL
                        </Button>
                        <SubmitButton type='button' variant='contained'>
                            ADD
                        </SubmitButton>
                    </div>
                </Form>
            </div>
        </Modal>
    );
};

CreateBillingAddress.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    user: PropTypes.shape({
        ID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        Email: PropTypes.string.isRequired
    }).isRequired,
    validatePermissionToPerformAction: PropTypes.func.isRequired
};
